import {
  Checkmark
} from "./chunk-SLQWD5HD.mjs";

// src/multiselect/src/components/react-select-components/option.tsx
import { components } from "react-select";
import { cva, cx } from "class-variance-authority";
import { useMemo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
function isInnerOption(option) {
  return "value" in option;
}
var Option = ({ children, ...props }) => {
  const hasChildren = useMemo(
    () => props.options.some(
      (option) => isInnerOption(option) && option.parentValue === props.data.value
    ),
    [props.data.value, props.options]
  );
  const wrapperClassname = cx({
    "mt-2 border-t border-t-surface-strong pt-2 first-of-type:mt-0 first-of-type:border-t-0 first-of-type:pt-0": hasChildren
  });
  const container = cva("outline-none", {
    variants: {
      isChild: {
        true: "pl-6"
      },
      isFocussed: {
        true: "bg-surface-subtle"
      }
    }
  });
  return /* @__PURE__ */ jsx("div", { className: wrapperClassname, children: /* @__PURE__ */ jsx(
    "div",
    {
      className: container({
        isChild: props.data.isChild,
        isFocussed: props.isFocused
      }),
      children: /* @__PURE__ */ jsx(components.Option, { ...props, children: /* @__PURE__ */ jsxs("span", { className: "flex cursor-pointer gap-2 p-2", children: [
        /* @__PURE__ */ jsx(Checkmark, { selected: props.isSelected }),
        children
      ] }) })
    }
  ) });
};

export {
  Option
};
